import { render, staticRenderFns } from "./popupView.vue?vue&type=template&id=6c069308&scoped=true"
import script from "./popupView.vue?vue&type=script&lang=js"
export * from "./popupView.vue?vue&type=script&lang=js"
import style0 from "./popupView.vue?vue&type=style&index=0&id=6c069308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c069308",
  null
  
)

export default component.exports